import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateBlankStageset as CreateBlankStagesetMutation,
    CreateBlankStagesetVariables as CreateBlankStagesetVariables,
    CreateStagesetInputFieldInput,
} from 'nutshell-graphql-types';

import CREATE_BLANK_STAGESET from '../mutations/create-stageset.graphql';

export const useCreateBlankStageset = (): {
    createBlankStageset: (arg1: CreateStagesetInputFieldInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createBlankStageset, {loading, error}] = useMutation<
        CreateBlankStagesetMutation,
        CreateBlankStagesetVariables
    >(CREATE_BLANK_STAGESET);

    return {
        createBlankStageset: (input: CreateStagesetInputFieldInput) =>
            createBlankStageset({variables: {stageset: input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
